import React, { useState, useCallback, useEffect } from "react";
import Modal from "../../Common/Modal";
// import {ReactComponent as IconCalendar} from "../../../Icons/Report/Calendar.svg";
import IconCalendar from "../../../Icons/Report/Calendar.svg";
import "./EventLog.css";
import CalendarCard from "../../Cards/CalendarCard";
import DateUtil from "../../../Utility/DateUtil";

type Props = {
  date: Date;
  maxDate?: Date;
  minDate?: Date;
  setDate: (date: Date) => void;
  style?: React.CSSProperties;
  className?: string;
};

export default function DatePicker({ date, maxDate, minDate, setDate, className, style }: Props) {
  const [dateString, setDateString] = useState(DateUtil.toString(date));
  const [calendarCardShowed, setCalendarCardShowed] = useState(false);

  const onChangeDate = useCallback((value) => {
    setDateString(value);
  }, []);

  useEffect(() => {
    setDateString(DateUtil.toString(date));
  }, [date]);

  const onKeyDownDate = useCallback(
    (key) => {
      const dateArray = DateUtil.parseDateString(dateString);
      if (key === "Enter" && dateArray !== []) {
        const day = dateArray[0];
        const month = dateArray[1];
        const year = dateArray[2];

        if (!DateUtil.isValidDate(day, month, year)) {
          setDateString("");
        }
      }
    },
    [dateString]
  );

  const onBlurInput = useCallback(() => {
    const dateArray = DateUtil.parseDateString(dateString);
    if (dateArray !== []) {
      const day = dateArray[0];
      const month = dateArray[1];
      const year = dateArray[2];

      if (!DateUtil.isValidDate(day, month, year)) {
        setDateString("");
      }else{
        setDate(DateUtil.toDate(dateString));
      }
    }
  }, [dateString, setDate]);

  const onChangeCalendar = (date: Date) => {
    setDateString(DateUtil.toString(date));
    setDate(date);
    setCalendarCardShowed(false);
  };

  return (
    <div
      style={{
        position: "relative",
        ...style,
      }}
      className={className}
    >
      <input
        className="event-log-form-input"
        value={dateString !== "" ? dateString : "-"}
        onChange={(e) => onChangeDate(e.target.value)}
        onKeyDown={(e) => onKeyDownDate(e.key)}
        onClick={() => setCalendarCardShowed(true)}
        onBlur={() => onBlurInput()}
        type="text"
        style={{
          background: `url(${IconCalendar}) 98% / 24px no-repeat, #FFFFFF`,
        }}
        maxLength={10}
      />
      <Modal
        show={calendarCardShowed}
        onHide={() => setCalendarCardShowed(false)}
        className="event-log-calendar-modal"
        classNameBackdrop="modal-calendar-backdrop"
        relativeToParent={true}
      >
        <Modal.Body>
          <CalendarCard date={DateUtil.toDate(dateString)} maxDate={maxDate} minDate={minDate} onChange={onChangeCalendar} />
        </Modal.Body>
      </Modal>
    </div>
  );
}
